export default __webpack_public_path__ + "static/media/glitch20.388db774.png";